import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

/**
 * Layout - wraps every routed page with the global Header and Footer.
 * The router renders the page inside <Outlet>.
 *
 * ScrollToTop lives here so EVERY route change resets scroll (or jumps to
 * an anchor if the URL has #hash).
 *
 * The skip-link at the top is only visible on focus - keyboard users tabbing
 * into the page jump straight to <main> without traversing the header nav.
 */
const Layout = () => {
  return (
    <div className="min-h-screen bg-bg-canvas text-text-primary antialiased flex flex-col">
      <ScrollToTop />

      {/* Skip-to-main-content link - invisible until keyboard-focused */}
      <a
        href="#main-content"
        className="skip-link sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:rounded-lg focus:bg-accent-primary focus:text-white focus:font-semibold focus:shadow-glow-sky"
      >
        Skip to main content
      </a>

      <Header />
      <main id="main-content" className="flex-1" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
